import { render, staticRenderFns } from "./LeftPanelSpectrum.vue?vue&type=template&id=48cc501b&scoped=true&"
import script from "./LeftPanelSpectrum.vue?vue&type=script&lang=js&"
export * from "./LeftPanelSpectrum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc501b",
  null
  
)

export default component.exports